import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useStyles } from './DisciplinesTab.styles'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import CustomTable from 'src/components/PostGraduationContent/PostgraduateComponents/Table/CustomTable'

const disciplines = [
  { name: 'Introdução à Segurança e à Privacidade', cred: 1, work: 16 },
  { name: 'Redes e Computação em Nuvem', cred: 2, work: 32 },
  { name: 'Metodologia de Pesquisa Científica', cred: 1, work: 16 },
  { name: 'Desenvolvimento Seguro de Software', cred: 1, work: 16 },
  { name: 'Aprendizado de Máquina', cred: 2, work: 32 },
  { name: 'Segurança da Informação e Criptografia', cred: 1, work: 16 },
  { name: 'Palestras Técnicas em Segurança e Privacidade', cred: 2, work: 32 },
  { name: 'Segurança em Redes de Computadores', cred: 1, work: 16 },
  { name: 'Segurança em Aplicações Web', cred: 1, work: 16 },
  { name: 'Segurança em Aplicações Móveis e IoT', cred: 1, work: 16 },
  { name: 'Certificações e Entidades Certificadoras', cred: 1, work: 16 },
  { name: 'Leis e Regulamentações', cred: 1, work: 16 },
  { name: 'Algoritmos Distribuídos e Blockchain', cred: 2, work: 32 },
  { name: 'Segurança e Privacidade de Dados', cred: 2, work: 32 },
  { name: 'Vulnerabilidade em Sistemas Operacionais (Hardening)', cred: 1, work: 16 },
  { name: 'Análise de Malware', cred: 1, work: 16 },
  { name: 'Aprendizagem de Máquina Aplicada a Segurança', cred: 1, work: 16 },
  { name: 'Segurança em Nuvens Computacionais', cred: 1, work: 16 },
  { name: 'Segurança Cibernética e Processamento de Imagem', cred: 1, work: 16 },
  { name: 'Computação Forense', cred: 1, work: 16 },
  { name: 'Total', cred: 25, work: 400 }
]

const DisciplinesTab = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()

  const tableRows = disciplines.map((discipline) => [
    discipline.name,
    ('0' + discipline.cred).slice(-2),
    `${discipline.work} horas`
  ])
  return (
    <>
        <Typography variant="h3" className={globalClasses.titleSectionVariant2}>
          {t('news.postgraduate.disc.tab-title')}
        </Typography>
      <Box className={classes.contentContainer}>
        <Typography className={classes.paragraph}>
          {t('news.postgraduate.disc.p1')}
        </Typography>
        <Box className={classes.tableContainer}>
          <CustomTable
            headers={[
              t('news.postgraduate.disc.tab-title'),
              t('news.postgraduate.disc.cred'),
              t('news.postgraduate.disc.hours')
            ]}
            rows={tableRows}
            highlightLastRow
            centerColumns={[1, 2]}
          />
        </Box>
      </Box>
   </>
  )
}

export default DisciplinesTab
